import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { chartsTooltipClasses } from "@mui/x-charts";

import { Colors } from "../../config";

const VerticalBarChart = ({ xdata = [], series = [], ...props }) => {
  const [height, setHeight] = useState(260);

  const colors = ["#54aea1", "#73a59e", "#6dc6f3", "#c3d8d5", "#d4fdf7"];

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2560) {
        setHeight(390);
      } else if (window.innerWidth < 2560 && window.innerWidth >= 2400) {
        setHeight(365);
      } else if (window.innerWidth < 2400 && window.innerWidth >= 2133) {
        setHeight(325);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(295);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(270);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(240);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(205);
      } else {
        setHeight(260);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const margin = {
    top: height * 0.015,
    right: height * 0.003,
    bottom: height * 0,
    left: height * -0.15,
  };

  return (
    <BarChart
      skipAnimation={false}
      height={height * 0.9}
      grid={{ horizontal: true }}
      yAxis={[
        {
          disableTicks: true,
          disableLine: true,
          tickLabelStyle: {
            fontSize: "0.875em",
            fontWeight: "600",
            display: "none",
          },
        },
      ]}
      xAxis={[
        {
          data: xdata,
          disableTicks: true,
          disableLine: true,
          tickLabelStyle: {
            fontSize: "0.875em",
            fontWeight: "600",
            // display: "none",
          },
        },
      ]}
      series={series}
      slotProps={{
        bar: (index) => ({
          style: {
            fill: colors[index.dataIndex] || Colors.main,
            stroke: Colors.main,
            strokeWidth: 1,
            clipPath: "inset(0 0 0 0 round 5px)",
          },
        }),
        tooltip: {
          sx: {
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]:
              {
                fontSize: height / 16,
              },
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.labelCell}`]:
              {
                fontSize: height / 18,
              },
          },
        },
      }}
      hideLegend={true}
      margin={margin}
      tooltip={{ trigger: "item" }}
      {...props}
    />
  );
};

export default VerticalBarChart;
